import React, {Component} from 'react';
import CSSModules from 'react-css-modules'
import config from '../../config'
import {
  Link,
  LinkIcon,
  // SocialButtons,
  GetStartedInput,
  AboutBanner
} from '../../components'
import Styles from './Resources.css'
import container from '../../helpers/container'

@CSSModules(Styles, {allowMultiple:true})
export default class Resources extends Component {
  constructor(props) {
    super(props)
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  renderResourcesContent = (message, url) => {
    return (
      <div styleName='resources'>
        <div styleName='resources-inner'>

          <div styleName='title'>
            Resources
          </div>
          <div styleName='subtitle'>
            Fossil free investing resources
          </div>

          { /* <SocialButtons message={message} link={url}/> */ }

          <p styleName='answer-lede'><em>As You Sow is not an investment advisor, nor do we provide financial planning, legal or tax advice. Nothing on this website shall constitute or be construed as an offering of financial instruments, or as investment advice or investment recommendations. <Link to={config.routes.legal} title='Legal' xstrong>See our full disclaimer<LinkIcon /></Link></em></p>

          <div styleName='answer-title'>
            Financial consulting firms
          </div>

          <p styleName='answer-lede'>Financial consultants provide financial advice to corporations and money managers, including company HR or finance teams that manage employee retirement plans. The firms below focus on integrating socially responsible investments into their financial advice.</p>

          <p><Link to={'https://socialk.com/'} xstrong title='Social K'>Social K</Link> &mdash; Social K is a financial consulting firm helping manage retirement plans with environmental, social, and governance considerations. They work alongside company or non-profit organization HR or finance teams to help them to design a retirement plan which is tailor-fit.</p>

          <p><Link to={'http://www.greenretirement.com/greenretirement.aspx'} xstrong title='Green Retirement'>Green Retirement</Link> &mdash; Green Retirement Plans is a B Corporation specializing in setting up small business 401(k), nonprofit organization 403(b), and individual IRA plans that include sustainable and socially responsible investments.</p>

          <p><Link to={'https://portal.valuesadvisor.org/ays'} xstrong title='ValuesAdvisor'>ValuesAdvisor</Link> &mdash; ValuesAdvisor is a nonprofit platform that connects you with values-aligned financial advisors recommended by impact investors, helping you secure your financial future while addressing the world's most pressing environmental problems. They provide access to their proprietary database to find advisors who align with your sustainable investing goals.</p>

          <div styleName='answer-title'>
            Brokerage services
          </div>

          <p styleName='answer-lede'>If you’ve found mutual funds or ETFs on Fossil Free Funds that fit your investing circumstances, you can use traditional brokerage services to invest in them directly or through an IRA portfolio. You can use traditional financial brokers to invest, or search online to find online brokerage services.</p>

          <div styleName='answer-title'>
            Automated socially responsible investing services
          </div>

          <p styleName='answer-lede'>"Robo-advisors" are a class of financial advisor that provide financial advice or investment management online with moderate to minimal human intervention, helping keep fees low. You can search online to find advisors that offer automated platforms that integrate environmental concerns, and other socially responsible investment issues.</p>


          <div styleName='answer-title'>
            Responsible investing and fossil fuel divestment educational resources
          </div>

          <p styleName='answer-lede'>If you’re looking to get more informed on fossil fuel divestment, fossil free investing, and other socially responsible investment issues, the educational resources below can help.</p>

          <p><Link to={'https://www.ussif.org/'} xstrong title='US-SIF'>US-SIF</Link> &mdash; US SIF: The Forum for Sustainable and Responsible Investment is a United States-based membership association that advances sustainable, responsible and impact investing across all asset classes. They can also help you find responsible investment managers to move your money fossil free.</p>

          <p><Link to={'https://www.greenamerica.org/divest-reinvest'} xstrong title='Green America'>Green America</Link> &mdash; Green America is a nonprofit membership organization based in the United States that promotes ethical consumerism. Their “Creating a Fossil Free Portfolio” guide teaches you how to get started investing fossil free.</p>

          { /* <p><Link to={'https://divestinvestguide.org/'} xstrong title='DivestInvest Guide'>DivestInvest Guide</Link> &mdash; The DivestInvest Guide, from <Link to={'https://www.divestinvest.org/'} xstrong title='DivestInvest'>DivestInvest</Link>, is a collection of resources covering investment and banking choices that can help reduce the risks of abrupt and irreversible climate change.</p> */ }

          <p><Link to={'https://gofossilfree.org/'} xstrong title='Go Fossil Free'>Go Fossil Free</Link> &mdash; The Go Fossil Free campaign, from <Link to={'https://350.org/'} xstrong title='350.org'>350.org</Link>, is a hub for campaigns working towards a fast and just transition to 100% renewable energy for all.</p>

          <div styleName='answer-title'>
            Partners and research providers
          </div>

          <p styleName='answer-lede'>Financial research providers help Fossil Free Funds identify fossil fuel companies in common mutual funds. The firms listed below all provide expertise and company research to help Fossil Free Funds track fossil fuel investments and keep our data up-to-date.</p>

          <p><Link to={'https://www.ffisolutions.com'} xstrong title='FFI Solutions'>FFI Solutions</Link> &mdash; FFI Solutions provides research products and investment solutions that reduce environmental risk while managing portfolio risk. They provide the Carbon Underground 200 index used by Fossil Free Funds, identifying the top global 200 publicly-owned coal, oil, and gas reserve owners ranked by the carbon emissions embedded in their reserves.</p>

          <p><Link to={'https://macroclimate.com/'} xstrong title='Macroclimate'>Macroclimate</Link> &mdash; Macroclimate is a B Corporation and fiduciary advisor that helps you invest in impact investment portfolios. They also provide investment research, including the Macroclimate 50 index used by Fossil Free Funds, identifying the 50 largest public-company owners of coal-fired power plants in Developed Markets plus China and India.</p>

          <p><Link to={'http://www.corporateknights.com/'} xstrong title='Corporate Knights'>Corporate Knights</Link> &mdash; Corporate Knights is a media, research and financial information products company focused on promoting “clean capitalism”, where prices fully incorporate social, economic and ecological costs and benefits. They partner with As You Sow to provide the Carbon Clean 200 index used by Fossil Free Funds, identifying the 200 largest publicly listed companies by their total clean energy revenues.</p>

          <p><Link to={'http://www.morningstar.com/company/sustainability'} xstrong title='Morningstar'>Morningstar</Link> &mdash; Morningstar is an investment research company offering mutual fund, ETF, and stock analysis, ratings, and data, and portfolio tools. In addition to providing the fund and company data that powers Fossil Free Funds, they offer Sustainability Rating for funds evaluating how well the companies in a fund’s portfolio are managing the environmental, social, and governance—or ESG—investing factors relevant to their industries.</p>

          <p><Link to={'https://yoursri.com/'} xstrong title='yourSRI.com/CSSP'>yourSRI.com/CSSP</Link> &mdash; With its online platform yourSRI.com, CSSP helps asset managers and asset owners worldwide to adequately manage risks related to ESG and Carbon issues. yourSRI.com provides the carbon footprint data for mutual funds that you find on Fossil Free Funds.</p>

        </div>
      </div>
    )
  }

  render() {
    const title = 'Resources'
    const description = 'Get your money out of fossil fuels. Find resources for investing fossil free.'
    const url = config.domain + config.routes.resources

    const message = 'Resources for investing fossil free'

    // const bannerImage = 'green'
    // const bannerHeadline = 'Resources'
    // const bannerSubtitle = 'Resources for investing fossil free'

    return (
      <div>
        {container.helmet(title, description, url)}

        { /* <div styleName='image-banner-container'>
          <div styleName='image-banner-container-inner'>
            <div styleName={'image-banner-'+bannerImage}>
              <div styleName='image-banner-headline'>{bannerHeadline}</div>
              <div styleName='image-banner-subtitle'>{bannerSubtitle}</div>
            </div>
          </div>
        </div> */ }

        { this.renderResourcesContent(message, url) }

        <GetStartedInput />

        <div styleName='resources'>
          <div styleName='resources-inner'>
            <AboutBanner />
          </div>
        </div>

      </div>
    )
  }
}
